import { WalletConnect as WalletConnectV2 } from "@web3-react/walletconnect-v2";

import { initializeConnector } from "@web3-react/core";

const CHAIN = process.env.REACT_APP_CHAIN_ID;

export const [walletConnectV2, hooks] = initializeConnector(
  (actions) =>
    new WalletConnectV2({
      actions,
      options: {
        projectId: "56e76179389975627afbbb8fdb7d6712",
        chains: [CHAIN],
        optionalChains: [CHAIN],
        showQrModal: true,
      },
      timeout: 10000,
      onError: (err) => {
        // console.log("erron in connector::::", err);
      },
    }),
);
